import type { FunctionComponent } from 'react';
import { BookText, ExternalLink } from 'lucide-react';

import type { BlocklistResult } from '@ballerine/business-analysis-schemas';

import { BlocklistStatusBadge } from '../../report-shared/BlocklistStatusBadge/BlocklistStatusBadge';
import { BlocklistWidget } from '../../report-shared/BlocklistWidget';
import { ReportWrapper } from '../../report-shared/components/ReportWrapper';

type BlocklistMatchesSectionProps = {
  blocklist?: BlocklistResult | null;
  blocklistConfigUrl?: string;
};

/**
 * The matches-table widget (BAL-7467). The clear state stays hidden by design — the section
 * renders solely when there are matches, so the header badge only ever shows "Blocklisted"
 * in practice.
 */
export const BlocklistMatchesSection: FunctionComponent<BlocklistMatchesSectionProps> = ({
  blocklist,
  blocklistConfigUrl,
}) => {
  if (!blocklist || blocklist.matches.length === 0) {
    return null;
  }

  return (
    <ReportWrapper
      title="Blocklist"
      showTooltip={false}
      headerAction={
        <div className="flex items-center gap-4">
          {blocklistConfigUrl && (
            <a
              href={blocklistConfigUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-xs text-[#97a3b6] hover:text-gray-500"
            >
              <BookText className="h-4 w-4" />
              Customer Blocklist
              <ExternalLink className="h-3 w-3 text-[#007aff]" />
            </a>
          )}
          <BlocklistStatusBadge blocklist={blocklist} variant="inline" />
        </div>
      }
    >
      <BlocklistWidget matches={blocklist.matches} />
    </ReportWrapper>
  );
};
